import { Routes, Route, useParams } from "react-router-dom";

import MainPage from "../../pages/MainPage";
import AboutUsPage from "../../pages/AboutUsPage";
import CategoriesPage from "../../pages/CategoriesPage";
import ProductsPage from "../../pages/ProductsPage";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { Box, Flex } from "@chakra-ui/react";
import Login from "../../pages/Login";
import Signup from "../../pages/Signup";
import ComingSoonPage from "../../pages/ComingSoonPage";
import ConfirmEmailPage from "../../pages/ConfirmEmailPage";
import { useEffect } from "react";
import ForgotPassword from "../../pages/ForgotPassword";
import getUserFromLocalStorage from "../../utils/getUsetFromLocalStorage";
import { transformUserData } from "../../utils/transformUserData";
import LoginToAllSite from "../LoginToAllSite/LoginToAllSite";
import SearchPage from "../../pages/SearchPage";
import { Helmet } from "react-helmet";
import { useAtom } from "jotai";
import { rememberUser, userInfoAtom } from "../../atom/user";
import FaqPage from "../../pages/Faq";
import VendorRegistration from "../../pages/VendorRegistration";

import Giveaway from "../../pages/Giveaway";
import {
  useGlobalEventListeners,
  usePageTracking,
} from "../../utils/analytics";
import ContactUs from "../../pages/CountactUs";
import { data } from "../../data";
import MainPageStorylaneOverlay from "../MainPageSections/MainPageStorylaneOverlay";

import TermsAndPrivacy from "../../pages/TermsAndPrivacy";
import GiveawayTermsAndPrivacy from "../../pages/GiveawayTermsAndPrivacy";

function App() {
  const [, setUserId] = useAtom(userInfoAtom);
  const [rememberMe] = useAtom(rememberUser);

  usePageTracking();
  useGlobalEventListeners();

  useEffect(() => {
    getUserFromLocalStorage(rememberMe)
      .then((attributes) => {
        setUserId(transformUserData(attributes));
      })
      .catch((err) => console.log(err));

    // eslint-disable-next-line
  }, []);

  const DynamicRouteHandler = () => {
    const { slug } = useParams();

    const categories = data.map(({ categoryLink }) => categoryLink);

    if (slug && categories.includes(slug)) {
      return <CategoriesPage />;
    }

    return <ProductsPage slider />;
  };

  return (
    <Flex flexDirection={"column"} minH={"100%"}>
      <Helmet>
        <title>
          BulletScout | Compare Ammunition Prices, Find Cheap Ammo | 2025
        </title>
        <meta
          name="description"
          content="Premier ammo search engine for finding the cheapest ammunition prices online in 2025. Rifle, pistol, rimfire, and shotgun ammo in bulk."
        />
      </Helmet>

      <LoginToAllSite />
      <Header />

      <Box flex={"1 1 auto"}>
        {/* <DemoBanner /> */}
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="about-us" element={<AboutUsPage />} />
          <Route path=":slug" element={<DynamicRouteHandler />} />
          <Route path="/*" element={<ProductsPage />} />
          <Route path="login" element={<Login />} />
          <Route path="signup" element={<Signup />} />
          <Route path="registration" element={<VendorRegistration />} />
          <Route path="coming-soon" element={<ComingSoonPage />} />
          <Route path="confirm-email/:userSub" element={<ConfirmEmailPage />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="search" element={<SearchPage />} />
          <Route path="faq" element={<FaqPage />} />
          <Route path="giveaway" element={<Giveaway />} />
          <Route path="contact-us" element={<ContactUs />} />
          <Route path="terms-and-privacy" element={<TermsAndPrivacy />} />
          <Route path="giveaway-terms-and-conditions" element={<GiveawayTermsAndPrivacy />} />
          <Route
            path="demo"
            element={
              <Box mt={"50px"}>
                <MainPageStorylaneOverlay />
              </Box>
            }
          />
        </Routes>
      </Box>
      <Footer />
    </Flex>
  );
}

export default App;
